/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Type, ViewContainerRef, ComponentRef } from '@angular/core';
import { Constructor } from '@angular/cdk/table';


/**
 * BaseViewComponentTrait
 *
 * Viewの基底クラス
 * コンポーネント用処理の分割クラス
 */
export function BaseViewComponentTrait<T extends Constructor<{}>>(Target: T) {
return class extends Target {

	////////////////////////////////////////////////////////////////////////////////////
	// コンポーネント操作


	/**
	 * renewComponent
	 *
	 * コンポーネントの差し替え。
	 * 今ある中身を消して、指定された物に変更する
	 * @param componentClass 表示クラス
	 * @param target 差し込むコンテナ
	 */
	public renewComponent(componentClass: Type<any>, target: ViewContainerRef): any {
		// コンテナにすでに存在しているコンポーネントを削除
		target.clear();
		// 新しいコンポーネントをコンテナに詰めて返す
		return this.addNewComponent(componentClass, target);
	}

	/**
	 * addNewComponent
	 *
	 * 新しいComponentの追加差し込み
	 * コンテナに含まれるコンポーネントの最後尾に追加する
	 * @param componentClass 表示クラス
	 * @param target 差し込むコンテナ
	 */
	public addNewComponent(componentClass: Type<any>, target: ViewContainerRef) {

		// コンポーネントクラスを生成するファクトリーを準備して、コンポーネントを生成
		const component = target.createComponent(componentClass);
		component.changeDetectorRef.detectChanges(); // パーツのダーティフラグついてるヤツをチェックして完成するまでブロック

		return component;
	}

	/**
	 * removeAllComponent
	 * 参照に入っている全コンポーネントの除去
	 * @param target ターゲット
	 */
	public removeAllComponent(target: ViewContainerRef) {
		// コンテナにすでに存在しているコンポーネントを削除
		target.clear();
	}

	/**
	 * removeComponent
	 * コンポーネントの除去。指定されたコンポーネント参照のものを除去。
	 * @param target ターゲット
	 */
	public removeComponent(viewRef: ViewContainerRef, comRef: ComponentRef<any> ) {

		// 存在しないときはなにもしない
		if (viewRef.indexOf(comRef.hostView) < 0) {
			return;
		}

		// index指定で、コンテナに存在しているコンポーネントを削除
		// comRef は、this.addnewComponent で作成されたもの。
		viewRef.remove(viewRef.indexOf(comRef.hostView));

	}

	/**
	 * createStartComponent
	 *
	 * コンポーネント中で、別のコンポーネントを作成する時のセット処理。
	 * addNewComponent は、中でdetectChanges呼んでる。 これは、パーツのダーティフラグついてるヤツをチェックして完成するまでブロックされている模様。
	 *
	 * @param parts 作成したコンポーネントのクラス
	 * @param container 作成したい場所の参照
	 * @param callBackProc 省略可。start()の前に実行したい処理。
	 * @returns 作成したコンポーネントのインスタンス
	 */
	public createStartComponent(parts: any, container: any, callBackProc = null ): any {

		// インスタンスを作成してDOMに入れる。
		const compRef = this.addNewComponent(parts, container);
		const comp = compRef.instance;

		// start()前に、やりたい処理を貰ったら、それを実行する。
		if (callBackProc !== null ) { callBackProc(); }

		// 開始処理実行
		comp.start();

		return comp;

	}

	/**
	 * createStartComponent()のcallBackProcで作成したコンポーネントに
	 * アクセスできるように変更したメソッド
	 *
	 * 親のコンポーネントからデータを受け渡したい場合に利用する
	 *
	 * @param parts
	 * @param container
	 * @param callBackProc
	 */
	public createStartWithInitialDataComponent(parts: any, container: any, callBackProc = null ): any {

		// インスタンスを作成してDOMに入れる。
		const compRef = this.addNewComponent(parts, container);
		const comp = compRef.instance;

		// start()前に、やりたい処理を貰ったら、それを実行する。
		if (callBackProc !== null ) { callBackProc(comp); }

		// 開始処理実行
		comp.start();

		return comp;

	}

	public renewStartComponent(parts: any, container: any, callBackProc = null ): any {
		// インスタンスを作成してDOMに入れる。
		const compRef = this.renewComponent(parts, container);
		const comp = compRef.instance;
		// start()前に、やりたい処理を貰ったら、それを実行する。
		if (callBackProc !== null ) { callBackProc(); }
		// 開始処理実行
		comp.start();
		return comp;
	}

	public renewStartWithInitialDataComponent(parts: any, container: any, callBackProc = null ): any {
		// インスタンスを作成してDOMに入れる。
		const compRef = this.renewComponent(parts, container);
		const comp = compRef.instance;
		// start()前に、やりたい処理を貰ったら、それを実行する。
		if (callBackProc !== null ) { callBackProc(comp); }
		// 開始処理実行
		comp.start();
		return comp;
	}
};
}
